import { Action, createReducer, on } from '@ngrx/store';
import { ChangePasswordState } from './change-password.models';
import { changePasswordReset, changePasswordSave, changePasswordSuccess } from './change-password.actions';

export const changePasswordState: ChangePasswordState = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
};

const reducer = createReducer(
    changePasswordState,
    on(changePasswordSave, (state, props) => ({
        ...state,
        currentPassword: props.currentPassword,
        newPassword: props.newPassword,
        confirmPassword: props.confirmPassword
    })),
    on(changePasswordReset, (state, props  ) => ({
        ...state,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    })),
    on(changePasswordSuccess, (state, props  ) => ({
        ...state,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    }))
);

export function changePasswordReducer(
    state: ChangePasswordState | undefined,
    action: Action
): ChangePasswordState {
    return reducer(state, action);
}
